import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserCompany } from '../interfaces/usercompany.interface';
import { UserControlView } from '../interfaces/user-control.interface';

@Injectable({
  providedIn: 'root'
})
export class UserCompanyService {


  readonly url: string = 'UserCompany';

	constructor(private http: HttpClient) {}

  public GetUserCompanyEntry(companyId: number): Observable<UserCompany> {
    return this.http.get<UserCompany>(this.url + '/' + companyId);
  }

  public GetAllUserCompanyEntries(companyId: number): Observable<UserCompany[]> {
    return this.http.get<UserCompany[]>(this.url + '/getAllUserCompanyEntries' + '/' + companyId)
  }

  public GetUserControlOverview(companyId: number): Observable<UserControlView[]> {
    return this.http.get<UserControlView[]>(this.url + '/getUserControlData/' + companyId)
  }

}
